import { getFullDependencyTree } from './get-full-dependency-tree';

export const getUsedInItemsByCodename = async (codename: string) => {
  const dependencyTree = await getFullDependencyTree();
  return dependencyTree[codename] || {};
};
